<template>
    <div >
        <div class="flex">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('saleInvoicing_to')"
                    :start-placeholder="$t('saleInvoicing_start_date')"
                    :end-placeholder="$t('saleInvoicing_end_date')">
            </el-date-picker>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">{{$t('saleInvoicing_affiliated_company')}}</span>
                <el-select @change="changeData($event,'glgs')" @clear="clearsearch('glgs')" class="marr4" v-model="i_iskp" size="mini" clearable filterable :placeholder="$t('saleInvoicing_please_select_whether_the_affiliated_company_will_issue_an_invoice')">
                    <el-option
                            v-for="item in GLdata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">{{$t('saleInvoicing_associated_sales_order')}}</span>
                <el-select @change="changeData($event,'glxsd')" @clear="clearsearch('glxsd')" class="marr4" v-model="i_isforeign" size="mini" clearable filterable :placeholder="$t('saleInvoicing_please_select_whether_the_affiliated_company_will_issue_an_invoice')">
                    <el-option
                            v-for="item in GLxsddata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">{{$t('saleInvoicing_source')}}</span>
                <el-select @change="changeLy"  class="marr4" v-model="i_order_source" size="mini" clearable filterable >
                    <el-option
                            v-for="item in ly"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    :placeholder="$t('saleInvoicing_search')"
                    v-model="vc_search">
            </el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="opensheet">{{$t('saleInvoicing_report')}}</el-button>
        </div>
        <el-table
                border
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                v-loading="loading2"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="$t('saleInvoicing_customer')"
                    min-width="205">
            </el-table-column>
            <el-table-column
                    prop="vc_invoice_type"
                    :label="$t('saleInvoicing_invoice_leixing')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="i_istemp"
                    label=""
                    show-overflow-tooltip
                    width="95">
                <template slot-scope="scope">
                    <span :class="scope.row.i_istemp==1?'boxyu box marr4':''">{{scope.row.i_istemp==1?$t('saleInvoicing_face'):''}}</span>
                    <span v-if="scope.row.i_istemp==1" :class="scope.row.i_istemp_over==1?'boxyu boxbu green':'boxyu boxbu'">{{scope.row.i_istemp_over==1?$t('saleInvoicing_replenished'):$t('saleInvoicing_not_supplemented')}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('saleInvoicing_sales_number')"
                    show-overflow-tooltip
                    min-width="155">
               <!-- <template slot-scope="scope">
                    <span>
                        <span :class="scope.row.i_istemp==1?'boxyu box marr4':''">{{scope.row.i_istemp==1?'临':''}}</span>
                        <span v-if="scope.row.i_istemp==1" :class="scope.row.i_istemp_over==1?'boxyu boxbu green':'boxyu boxbu'">{{scope.row.i_istemp_over==1?'已补':'未补'}}</span>
                        {{scope.row.vc_xcode}}
                    </span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_kpname_sell"
                    :label="$t('saleInvoicing_invoice_item_name')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_pzspecs"
                    :label="$t('saleInvoicing_specification_model')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_kpbzstyle_sell"
                    :label="$t('saleInvoicing_invoice_specifications')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    :label="$t('saleInvoicing_unit')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="vc_kpunit_sell"
                    :label="$t('saleInvoicing_billing_entity')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <!--<el-table-column
                    prop="f_kpprice_sell"
                    label="开票单价"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_kpnum_sell"
                    label="开票数量"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>-->
            <el-table-column
                    prop="f_price"
                    :label="$t('saleInvoicing_order_unit_price')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_order_quantity_outbound_quantity_signed_receipt_quantity')"
                    show-overflow-tooltip
                    min-width="140"
                    align="right">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_kdnum+'/'+scope.row.f_outnum+'/'+scope.row.f_signnum+'/'+scope.row.f_backnum}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_pre_shipment_quantity_shipped_and_verified_quantity')"
                    show-overflow-tooltip
                    min-width="200"
                    align="right">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_ycknum+'/'+scope.row.f_yckhxnum}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_kycknum"
                    :label="$t('saleInvoicing_available_for_shipment_quantity')"
                    show-overflow-tooltip
                    min-width="111"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_pending_invoicing_order_volume')"
                    show-overflow-tooltip
                    min-width="100"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_invoicednum"
                    :label="$t('saleInvoicing_number_of_invoiced_orders')"
                    show-overflow-tooltip
                    min-width="110"
                    align="right">
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="f_backnum"-->
<!--                    :label="$t('saleInvoicing_return_quantity')"-->
<!--                    show-overflow-tooltip-->
<!--                    min-width="110"-->
<!--                    align="right">-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="f_amount"
                    :label="$t('saleInvoicing_kaipiao_amount')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <!--<el-table-column
                    prop="f_price_notax"
                    label="无税单价"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_amount_notax"
                    label="无税金额"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_sl"
                    label="税率"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_amount_tax"
                    label="税额"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_note"
                    :label="$t('saleInvoicing_invoice_remarks')"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_gsname"
                    label="销售方"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_thtype"
                    :label="$t('saleInvoicing_delivery_method')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kduname"
                    :label="$t('saleInvoicing_business')"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_lruname"
                    label="开单人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_creditcode"
                    :label="$t('saleInvoicing_customer_taxpayer_identification_number')"
                    show-overflow-tooltip
                    min-width="200">
            </el-table-column>
            <el-table-column
                    prop="vc_adress"
                    :label="$t('saleInvoicing_address_telephone')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_address+' '+scope.row.vc_tel }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    :label="$t('saleInvoicing_bank_and_account_number')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_bank+' '+scope.row.vc_bank_account }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_email"
                    :label="$t('saleInvoicing_invoice_receiving_email_address')"
                    show-overflow-tooltip
                    min-width="150">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_lruname"
                    label="申请人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="dt_applytime"
                    label="申请时间"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_state"
                    label="开票状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.i_state==0?'待提交':(scope.row.i_state==1?'已提交':'已开票') }}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="dt_yjdhtime"
                    :label="$t('saleInvoicing_estimated_arrival_time')"
                    show-overflow-tooltip
                    min-width="100">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_invoice_code"
                    label="发票代码"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column :label="$t('saleInvoicing_operation')" width="175" fixed="right">
                <template slot-scope="scope" >
                    <el-button size="mini" v-if="i_order_source==0"
                               type="text"
                               @click="handleyck(scope.$index, scope.row)">{{$t('saleInvoicing_transfer_to_pre_outbound')}}</el-button>
                    <el-button size="mini"
                               type="text"
                               @click="handleAdd(scope.$index, scope.row,0)">{{$t('saleInvoicing_new')}}</el-button>
                    <el-button size="mini"
                               type="text"
                               @click="handleAdd(scope.$index, scope.row,4)">{{$t('saleInvoicing_switch_to_offline')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="flex_e padT6 mrr9">
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="pladd(0)">{{$t('saleInvoicing_batch_add')}}</el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="pladd(4)">{{$t('saleInvoicing_batch_offline_transfer')}}</el-button>
        </div>
        <div>
            <el-pagination
                    class="flex_e padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>
            <!--<div class="flex_b alc">
                <div>
                    {{'已选'+ ' '+multipleSelection.length+' '+'条'}}
                </div>
                <el-button :class="baseerp+'btn'"  size="small"  @click="sure">确定</el-button>
                &lt;!&ndash;<div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'"  size="small" type="primary">确定</el-button>
                </div>&ndash;&gt;
            </div>-->
        </div>
        <!--dialog-->
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                width="1000px"
                :title="title"
                :visible.sync="dialogVisible_add"
                :close-on-click-modal="false"
                @close="cancelDialog_add"
                v-if="dialogVisible_add"
                :append-to-body="true">
            <add-kp :addData="addData"  @cancelDialog_add="cancelDialog_add"></add-kp>
        </el-dialog>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                width="85%"
                :title="$t('saleInvoicing_pre_release_list')"
                :visible.sync="dialogVisible_yck"
                :close-on-click-modal="false"
                @close="backyck"
                v-if="dialogVisible_yck"
                :append-to-body="true">
            <yck-list :addData="addData" @success="handleSubSuccess" @close="backyck"></yck-list>
        </el-dialog>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                width="85%"
                :title="$t('saleInvoicing_batch_invoice_processing')"
                :visible.sync="dialogVisible_pl"
                :close-on-click-modal="false"
                @close="plback"
                v-if="dialogVisible_pl"
                :append-to-body="true">
            <add-plkp :addData="addData" @close="plback"></add-plkp>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import addKp from "./addKp";
    import yckList from "./yckList";
    import addPlkp from "./addPlkp";
    export default {
        name: "",
        components: {
            addKp,
            yckList,
            addPlkp,
        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                isNeedRefresh: false,
                i_isforeign:null,
                GLxsddata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_domestic')},{i_id:1,vc_name:this.$t('saleInvoicing_foreign_countries')}],
                i_iskp:null,
                GLdata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_uninvoiced')},{i_id:1,vc_name:this.$t('saleInvoicing_invoiced')}],
                baseerp:"",
                mid:0,
                title:this.$t('saleInvoicing_new_invoice_issuance'),
                dialogVisible_add:false,
                dialogVisible_sheet:false,
                dialogVisible_yck:false,
                dialogVisible_pl:false,
                addData:{},
                i_gsid:0,
                loading2:true,
                vc_search:"",
                highlightCurrentRow:false,
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                multipleSelection_2:[],
                tableHeight:0,
                i_order_source:0,
                ly:[{i_id:0,vc_name:'ERP'},{i_id:1,vc_name:this.$t('saleInvoicing_nanbei_export')}]
            }
        },

        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            // console.log('data',this.Data);
            this.i_gsid = this.Data.i_gsid;
            this.getfMou();
            /*this.$nextTick(function () {
                this.onResize();
            });*/

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods:{

            /*onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 160;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                // console.log(n.h,this.tableHeight)
            },*/
            updateTableHeight() {
                //console.log(this.Data.maxDialogHeight,'this.Data.maxDialogHeight');
                const dialogHeight = this.Data.maxDialogHeight; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =320;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.Data.maxDialogHeight;
            },
            handleyck(index, row){
                if(row.i_type_sel==1){
                    this.$message.error(this.$t('saleInvoicing_batch_specific_non_transferable_pre_shipment'));
                    return;
                }
                this.addData={
                    row: row,
                    maxDialogHeight:this.maxDialogHeight,
                }
                this.dialogVisible_yck=true;
            },
            handleSubSuccess() {
                this.isNeedRefresh = true;
            },
            backyck() {
                this.addData={};
                this.dialogVisible_yck=false;
                if (this.isNeedRefresh) {
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                    this.isNeedRefresh = false;
                }
            },
            changeLy(){
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeData(e, type) {
                if (type == 'glgs') {
                    this.i_iskp = e;
                }
                if (type == 'glxsd') {
                    this.i_isforeign = e;
                }
            },
            clearsearch(type) {
                if (type == 'glgs') {
                    this.i_iskp = null;
                }
                if (type == 'glxsd') {
                    this.i_isforeign = null;
                }
            },
            opensheet(){
                let arg={
                    "i_gsid": this.i_gsid,
                    "vc_search": this.vc_search,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                };
                this.$emit('bbSheet',arg);
            },
            plback(val){
                this.dialogVisible_pl=false;
                if(val){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }
            },
            pladd(state){
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('saleInvoicing_please_select_batch_addition_offline_batch_invoices'));
                    return;
                }
                let arr = [] ;
                arr = this.multipleSelection.map(row=>{
                    return {
                        "vc_xcode":row.vc_xcode,
                        "i_pzid":row.i_pzid,
                    }
                });
                this.addData={
                    arr:arr,
                    maxDialogHeight:this.maxDialogHeight,
                    i_state:state,
                    i_invoice_source:state==0?1:2
                }
                this.dialogVisible_pl=true;
            },
            plset(type){
                //console.log('type',type)
                this.$confirm(this.$t('saleInvoicing_confirm_whether_to_batch_add_offline_invoice_issuance'), this.$t('saleInvoicing_hint'), {
                    confirmButtonText: this.$t('saleInvoicing_sure'),
                    cancelButtonText: this.$t('saleInvoicing_cancel'),
                    type: 'warning'
                }).then(() => {
                    //console.log(' this.multipleSelection', this.multipleSelection)
                    if(type=='add'){
                        this.saveForm()
                    }else if(type=='down'){
                        this.offline(this.multipleSelection)
                    }

                }).catch(() => {

                });
            },
            //保存
            async saveForm(){
                let kong = this.multipleSelection.some(item=>{
                    return item.vc_creditcode==''
                })
                //console.log('kong',kong)
                if(kong){
                    this.$message.error(this.$t('saleInvoicing_please_go_to_the_oa_system_to_maintain_the_customer_s_taxpayer_identification_number'));
                    return;
                };
                //let alist=[];
                //alist.push(this.formData);
                this.loading2=true;
                let param={
                    delSub:[],
                    list:this.multipleSelection,
                };
                let res=await API.saveInvoice(param);
                if (res.code==1){
                    this.loading2=false;
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            returndown(index, row){
                this.$confirm(this.$t('saleInvoicing_is_offline_invoicing_confirmed'), this.$t('saleInvoicing_hint'), {
                    confirmButtonText: this.$t('saleInvoicing_sure'),
                    cancelButtonText:this.$t('saleInvoicing_cancel'),
                    type: 'warning'
                }).then(() => {
                    //console.log('row',row)
                    /*let map={
                        vc_xcode:row.vc_xcode,
                        i_pzid:row.i_pzid,
                    }*/
                    let arr=[];
                        arr.push(row);
                    //console.log('arr',arr)
                    this.offline(arr)
                }).catch(() => {

                });
            },
            //转线下开票
            async offline(arr){
                this.loading2=true;
                let param={
                    'list':arr,
                };
                var res = await API.offline(param);
                if (res.code==1){
                    this.loading2=false;
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            handleAdd(index, row,state){

                this.addData={
                    item:row,
                    maxDialogHeight:this.maxDialogHeight,
                    i_state:state,
                    i_invoice_source:state==0?1:2,
                    i_order_source:this.i_order_source,
                };
                if(state==4)this.title=this.$t('saleInvoicing_switch_to_offline');
                this.dialogVisible_add=true;
            },
            cancelDialog_add(val){
                this.addData={};
                this.dialogVisible_add=false;
                if(val=='new'){
                    this.$emit('cancelDialog',val)
                }else if(val=='kpzl'){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }
            },
            uniqueByKey(arr, key) {
                let seen = new Set();
                return arr.filter((item) => {
                    let keyValue = item[key];
                    if (seen.has(keyValue)) {
                        return false;
                    } else {
                        seen.add(keyValue);
                        return true;
                    }
                });
            },
            sure(){
                /*console.log(this.multipleSelection,'this.multipleSelection');
                console.log(this.multipleSelection_2,'this.multipleSelection_2');
                let uniqueItems = this.uniqueByKey(this.multipleSelection_2, 'uniqueKey');
                console.log('uniqueItems',uniqueItems);
                this.$emit('cancelDialog',uniqueItems)*/
            },
            handleSelectionChange(val) {
                //console.log(val,'val')
                this.multipleSelection = val;
                this.multipleSelection_2 = [...this.multipleSelection_2 , ...val];
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },

            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading2=true;
                /*let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }*/
                let param={
                    'i_mid':this.mid,
                    "i_gsid": this.i_gsid,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'i_order_source':this.i_order_source,
                };
                // console.log('调接口',this.vc_search,this.companyId);
                //return;
                //if(type==0){
                var res = await API.listBeforeInvoice(param);
                //}else if(type==1){
                //    var res = await API.listTd(param);
                //}
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading2=false;
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                    // console.log('this.multipleSelection_2',this.multipleSelection_2)
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },



        },
    }
</script>


<style  lang="scss" scoped>
    /deep/.el-table td{

    }
    .green{
        background-color: green !important;
    }
    .boxyu{
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .boxbu{
        width: 38px;
        height: 28px;
        line-height: 25px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }

    .flex_e{
        display: flex;
        justify-content: end;
    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }



</style>
